import type { AqsiSale, AqsiSeatActivity, AqsiSeatRefund } from './types'

/** Продажа кассы места; возврат на кассе — не продажа. */
export function saleOf(activity: AqsiSeatActivity | undefined): AqsiSale | null {
  return activity == null || isRefund(activity) ? null : activity
}

/** Возврат, занимающий кассу места, или `null`. */
export function seatRefundOf(activity: AqsiSeatActivity | undefined): AqsiSeatRefund | null {
  return activity != null && isRefund(activity) ? activity : null
}

/** Сравнение явное: появись у продажи своё поле `kind`, она не станет «возвратом» молча. */
function isRefund(activity: AqsiSale | AqsiSeatRefund): activity is AqsiSeatRefund {
  return 'kind' in activity && activity.kind === 'refund'
}
